import { FormData } from '../../../types/transaction';
import { useMemo } from 'react';

interface FinancialFormProps {
  formData: FormData;
  onChange: (data: FormData) => void;
}

export default function FinancialForm({ formData, onChange }: FinancialFormProps) {
  const calculateFeesWithoutTax = (feesWithTax: string) => {
    const withTax = parseFloat(feesWithTax.replace(/[^\d.-]/g, ''));
    if (!isNaN(withTax)) {
      const withoutTax = Math.round((withTax / 1.2) * 100) / 100;
      onChange({ ...formData, fees_with_tax: withTax.toString(), fees_without_tax: withoutTax.toString() });
    } else {
      onChange({ ...formData, fees_with_tax: '', fees_without_tax: '' });
    }
  };

  const handleSalePriceChange = (value: string) => {
    const price = parseFloat(value.replace(/[^\d.-]/g, ''));
    onChange({ ...formData, sale_price: isNaN(price) ? '' : price.toString() });
  };

  // Calculer les honoraires nets HT
  const netFeesWithoutTax = useMemo(() => {
    const feesWithoutTax = parseFloat(formData.fees_without_tax);
    const totalRetrocessions = formData.retrocessions.reduce((sum, r) => {
      const amount = parseFloat(r.amount);
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
    
    if (isNaN(feesWithoutTax)) return 0;
    return feesWithoutTax - totalRetrocessions;
  }, [formData.fees_without_tax, formData.retrocessions]);

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Prix de vente (€)
          </label>
          <input
            type="text"
            inputMode="decimal"
            value={formData.sale_price}
            onChange={(e) => handleSalePriceChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Honoraires TTC (€)
          </label>
          <input
            type="text"
            inputMode="decimal"
            value={formData.fees_with_tax}
            onChange={(e) => calculateFeesWithoutTax(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Honoraires Brut HT (€)
          </label>
          <input
            type="text"
            value={formData.fees_without_tax}
            readOnly
            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          />
        </div>
      </div>
    </div>
  );
}